// extracted by mini-css-extract-plugin
module.exports = {"counter":"TafsirText_counter__xlNaF","xs":"TafsirText_xs__P5Qjv","sm":"TafsirText_sm__BbfQ0","md":"TafsirText_md__mJWtv","lg":"TafsirText_lg__t_oGB","xl":"TafsirText_xl__3hmwr"};